import type { TypeId } from '@unipile/db';
import type { ProviderAuthenticationIntentResponse } from '@unipile/types';
import { useEffect } from 'react';
import { useSolveCheckpoint } from '../../../features/accounts/api/solve-checkpoint';
import { Spinner } from '../../shadcn/Spinner';
import { WizardStepContainer } from '../containers/WizardStepContainer';

export function LoadingCheckpoint({
  onSuccess,
  onError,
  intent_id,
  title,
  description,
}: {
  onSuccess: (response: ProviderAuthenticationIntentResponse) => void;
  onError: (error: unknown) => void;
  intent_id: TypeId<'account'>;
  title: string;
  description: string;
}) {
  const { mutate: mutateSolveCheckpoint } = useSolveCheckpoint({
    mutationConfig: {
      onSuccess,
      onError,
    },
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      mutateSolveCheckpoint({ data: { code: '', intent_id } });
    }, 0);

    return () => clearTimeout(timer);
  }, [intent_id, mutateSolveCheckpoint]);

  return (
    <WizardStepContainer title={title} description={description}>
      <div className="flex justify-center py-8">
        <Spinner className="size-8" />
      </div>
    </WizardStepContainer>
  );
}
